module.exports = __webpack_public_path__ + "static/media/hindsight_alt.4dbbc122.jpg";